import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { HishabpatiImageGallery } from "../../../components/image-gallery/hishabpati-gallery";

export const HishabpatiModalData = () => {
  const { hishabpatiModalState } = useContext<IAppContextState | any>(
    AppContext
  );
  const [isOpenHishabpatiModal, setOpenHishabpatiModal] = hishabpatiModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenHishabpatiModal}
      onClose={() => setOpenHishabpatiModal(false)}
    >
      <Modal.Header>Hishabpati Web</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <HishabpatiImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name:{" "}
                <span className="text-purple-600">Hishabpati</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="red" className="me-2 my-1">
                  Angular
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Bootstrap
                </Badge>
                <Badge color="pink" className="my-1">
                  SCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    HishabPati is a simple record-keeping app for businesses,
                    working smoothly online or offline with automatic data sync.
                    It offers an easy-to-use interface and helps manage everyday
                    transactions, inventory, and basic accounting.
                  </p>
                  <ul className="list-disc mt-4 ms-5">
                    <li>UI fully revamped using Bootstrap theming.</li>
                    <li>Numerous new pages developed during my tenure.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://app.hishabpati.com/"
                className="text-purple-600 hover:text-purple-700 hover:underline me-4"
              >
                Go to Hishabpati Web
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
